import { S as l, N as r } from "./SelfServicePanelService.js";
import { PdkSelfServicePanel as p } from "./PdkSelfServicePanel.js";
import { PdkDetailsPanel as u } from "./PdkDetailsPanel.js";
class c {
  static init(t) {
    typeof t < "u" && (t.PDK || (t.PDK = {})), t.PDK.SelfServicePanelService = l, t.PDK.NavigationService = r, t.document.addEventListener("DOMContentLoaded", () => {
      r.init(t, document), t.document.body.addEventListener("click", (o) => {
        const a = o.target;
        if (a.closest("[data-pdk-toggle]")) {
          const n = a.closest("[data-pdk-toggle]").getAttribute("data-pdk-target"), e = document.getElementById(n);
          e && (e.show = !e.show), o.stopPropagation();
          return;
        }
        if (a.closest("[data-pdk-close]")) {
          const n = a.closest("[data-pdk-close]").getAttribute("data-pdk-target"), e = document.getElementById(n);
          e && (e.show = !1), o.stopPropagation();
          return;
        }
        if (a.closest("[data-pdk-show]")) {
          const n = a.closest("[data-pdk-show]").getAttribute("data-pdk-target"), e = document.getElementById(n);
          e && (e.show = !0), o.stopPropagation();
          return;
        }
        if (l.handlePanelClickEvents(a)) {
          o.stopPropagation();
          return;
        }
      });
    });
  }
}
c.init(window);
export {
  r as NavigationService,
  u as PdkDetailsPanel,
  p as PdkSelfServicePanel,
  l as SelfServicePanelService
};
//# sourceMappingURL=index.js.map
